import { UserObject } from "../../../shared/types";

export type GuidePersona = {
  region: string;
  spec: string;
  bio: string;
};

type GuideCardProps = {
  userObj: UserObject;
  persona: GuidePersona;
};

/**
 * Circular-photo guide card with a hover-expand bio (CSS group-hover, mirroring the
 * OurTeam.dc.html `.guide:hover` reveal). region/spec/bio are presentational personas —
 * the user model only carries name/photo/role.
 */
const GuideCard = ({ userObj, persona }: GuideCardProps) => {
  return (
    <div className="group text-center">
      <div className="rounded-[20px] bg-white px-[22px] py-[26px] shadow-[0_14px_30px_-20px_rgba(0,0,0,0.25)] transition-[transform,box-shadow] duration-[400ms] ease-[cubic-bezier(0.2,0.7,0.2,1)] group-hover:-translate-y-1.5 group-hover:shadow-[0_28px_50px_-26px_rgba(0,0,0,0.4)]">
        <div className="mx-auto mb-4 h-28 w-28 overflow-hidden rounded-full shadow-[0_10px_24px_-10px_rgba(19,58,69,0.5)]">
          <img
            src={`${process.env.REACT_APP_API_URL}/img/users/${userObj.photo}`}
            alt={userObj.name}
            crossOrigin="anonymous"
            className="h-full w-full object-cover transition-transform duration-500 ease-[cubic-bezier(0.2,0.7,0.2,1)] group-hover:scale-105"
          />
        </div>
        <div className="text-[17px] font-bold text-ink">{userObj.name}</div>
        <div className="mt-1 font-mono text-[11.5px] tracking-[0.04em] text-secondary-400">
          {persona.region.toUpperCase()}
        </div>
        <div className="mt-2 text-[13px] text-muted-400">{persona.spec}</div>
        <div className="max-h-0 overflow-hidden opacity-0 transition-all duration-[450ms] ease-in-out group-hover:mt-3 group-hover:max-h-[160px] group-hover:opacity-100">
          <p className="border-t border-line-100 pt-3 text-[13px] leading-[1.55] text-muted">
            {persona.bio}
          </p>
        </div>
      </div>
    </div>
  );
};

export default GuideCard;
